import React, { useEffect, useState } from 'react';

export const GoogleMapsLocation = ({ street = '', postalCode = '', city = '', onCoordinates, hidden = false }) => {
  const [latLon, setLatLon] = useState({ lat: null, lon: null });

  const address = `${street}, ${postalCode} ${city}`.trim();

  useEffect(() => {
    if (!address) return;

    const fetchCoordinates = async () => {
      try {
        const response = await fetch(`https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(address)}&format=json`);
        const data = await response.json();
        if (data && data.length > 0) {
          const lat = parseFloat(data[0].lat);
          const lon = parseFloat(data[0].lon);
          setLatLon({ lat, lon });

          // Callback an Parent
          if (onCoordinates) onCoordinates({ lat, lon });
        }
      } catch (err) {
        console.error("Fehler beim Abrufen der Koordinaten:", err);
      }
    };

    fetchCoordinates();
  }, [address, onCoordinates]);

  const getMapUrl = () => {
    if (!latLon.lat || !latLon.lon) return '';
    return `https://maps.google.com/maps?q=${latLon.lat},${latLon.lon}&t=&z=15&ie=UTF8&iwloc=&output=embed`;
  };

  const hasAddress = street || postalCode || city;

  return (
    <div className={`w-full max-w-2xl mx-auto p-6 bg-white rounded-lg shadow-lg ${hidden ? "hidden" : ""}`}>
      <h2 className="text-2xl font-bold mb-6 text-gray-800">Standort</h2>
      {hasAddress ? (
        <iframe
          width="100%"
          height="300"
          style={{ border: 0 }}
          src={getMapUrl()}
          title="Google Maps Standort"
        />
      ) : (
        <p className="text-gray-500">Keine Adresse angegeben</p>
      )}
    </div>
  );
};
